import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2419543d")

_pushScopeId("data-v-2419543d")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Clienti")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Clienti")
const _hoisted_3 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "ion-text-center"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" La ricerca non ha prodotto risultati. ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")
  const _component_ion_text = _resolveComponent("ion-text")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")
  const _component_ion_fab = _resolveComponent("ion-fab")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_buttons, { slot: "primary" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    color: "secondary",
                    onClick: $setup.refreshCustomer
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        ios: "ellipsis-horizontal",
                        md: "ellipsis-vertical"
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_header, { collapse: "condense" }, {
            default: _withId(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_buttons, { slot: "primary" }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_button, {
                        color: "secondary",
                        onClick: $setup.refreshCustomer
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "icon-only",
                            ios: "ellipsis-horizontal",
                            md: "ellipsis-vertical"
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withId(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "primary"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode(_component_ion_searchbar, {
                  placeholder: "Ricerca clienti",
                  modelValue: $setup.searchTerm,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.searchTerm = $event)),
                  onIonChange: _cache[2] || (_cache[2] = ($event: any) => ($setup.filterItems($setup.searchTerm))),
                  debounce: "700"
                }, null, 8, ["modelValue"]),
                ($setup.clienti.length != 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _createVNode(_component_ion_list, null, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.showClienti, (cliente) => {
                            return (_openBlock(), _createBlock(_component_ion_item, {
                              key: cliente.customers_id,
                              onClick: ($event: any) => ($setup.openDetail(cliente.customers_id)),
                              button: "true",
                              detail: ""
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_text, { color: "primary" }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString($setup.riferimentoCliente(cliente)), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode("h3", null, _toDisplayString(cliente.customers_city) + " - " + _toDisplayString(cliente.customers_address), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_infinite_scroll, {
                        onIonInfinite: _cache[3] || (_cache[3] = ($event: any) => ($setup.loadData($event))),
                        threshold: "100px",
                        id: "infinite-scroll"
                      }, {
                        default: _withId(() => [
                          ($setup.customersToSearch)
                            ? (_openBlock(), _createBlock(_component_ion_infinite_scroll_content, {
                                key: 0,
                                "loading-spinner": "bubbles",
                                "loading-text": "Carico clienti ..."
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                ($setup.showClienti.length == 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode(_component_ion_text, { color: "danger" }, {
                        default: _withId(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])),
          _createVNode(_component_ion_fab, {
            horizontal: "end",
            vertical: "bottom",
            slot: "fixed"
          }, {
            default: _withId(() => [
              _createVNode(_component_ion_fab_button, {
                color: "success",
                onClick: $setup.refreshCustomer
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_icon, { icon: $setup.refresh }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})